module.exports = __webpack_public_path__ + "img/left-ad-1.f9b83c59.png";